<template>
  <hr class="divider" />
</template>

<style scoped>
@import '@/css/breakpoints.css';

.divider {
  border: none;
  margin-bottom: 3rem;
  position: relative;
  border-bottom: 2px solid rgba(0,0,0,0.5);
  overflow: visible;
  width: 100%;
  max-width: 100%;
}

.divider::before,
.divider::after {
  content: '';
  position: absolute;
  width: 1px;
  height: 4rem;
  border-right: 2px solid rgba(0,0,0,0.5);
}

@media (--phone) {
  .divider::before,
  .divider::after {
    content: '';
    position: absolute;
    width: 1px;
    height: 2rem;
    border-right: 1px solid rgba(0,0,0,0.5);
  }
}

.divider::before {
  top: 0;
  transform: translate(var(--inline-margin), 0rem);
}

.divider::after {
  transform: translate(calc(-1 * var(--inline-margin)), -0rem);
  bottom: 0;
  right: 0;
}
</style>
